export default function beforeAuth({ next, router }) {
    if (localStorage.getItem('token')) {
        return router.push({ name: 'Dashboard' });
    } 
  
    return next();
  }